import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { authCertsAction, authServerAction, setServiceType } from '../../../store/API/actions';
import { authError as authErrorAction, authFetch as authFetchAction } from '../../../store/API/actions';
import { APIState, serviceTypeEnum } from "../../../store/API/types";
import { ApplicationState } from "../../../store";

import loginBg from '../../../assets/images/bg-login.png';
import AuthFormComponent from "../AuthFormComponent";
import AuthBackgroundComponent from "../AuthBackgroundComponent";
import AuthFailedComponent from "../AuthFailedLoginComponent";
import AuthCertsComponent from '../AuthCerts';
import { checkCertsAvailability } from '../../../utils';
import SpinnerComponent from '../../reusable/SpinnerComponent';
import AuthDuoComponent from "../AuthDuoComponent";

// TODO
// Rewrite and split login logic

const AuthComponent = () => {
  const {authError, authFetch, authCerts, authCertsFetch, authDuoFetch, authDuoError} = useSelector<ApplicationState, APIState>(state => state.API);
  const dispatch = useDispatch();
  const serviceType = window.CONFIG.ServerType;

  const serverCheck = async () => {
    dispatch(setServiceType(serviceType));
    switch (serviceType) {
      case serviceTypeEnum.ocularis:
        if (await heartbeatCheck()) {
          if (await !certsCheck()) {
            await certsFilesCheck(['root-ca.crt', 'intermediate-ca.crt'])
          }
        }
        break;
      case serviceTypeEnum.cayuga:
        dispatch(authCertsAction(true));
        dispatch(authServerAction());
        break;
      default:
        dispatch(authErrorAction(`<span class="server">${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}</span> server is not responding or cannot be reached.`, 'Network Error'));
    }
  }

  const certsFilesCheck = async (certs: string[]) => {
    const certsFilesAvailability = await checkCertsAvailability(certs);

    if (certsFilesAvailability.length > 0) {
      dispatch(authFetchAction());
      dispatch(authErrorAction(`
                <span class="server">
                    Can't obtain ${certsFilesAvailability.map((cert: any) => cert.name)}
                    certificate from
                    ${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort} server.
                </span>
            `, 'Certificates Error'));
      return false;
    } else {
      return true;
    }
  }

  const certsCheck = async () => {
    try {
      await fetch(`https://${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}/img/spinner.gif`);
      dispatch(authCertsAction(true));
      return true;
    } catch (e) {
      dispatch(authCertsAction(false));
      return false;
    }
  }

  const heartbeatCheck = async () => {
    if (window.location.protocol === 'http:' && serviceType === serviceTypeEnum.ocularis) {
      try {
        await fetch(`http://${window.CONFIG.ServerAddress}:${window.CONFIG.OMSHTTPPort}/heartbeat`);
        dispatch(authServerAction());
        return true;
      } catch (e) {
        dispatch(authErrorAction(`<span class="server">${window.CONFIG.ServerAddress}:${window.CONFIG.ServerPort}</span> server is not responding or cannot be reached.`, 'Network Error'));
        return false;
      }
    } else {
      dispatch(authServerAction());
      return true;
    }
  }

  useEffect(() => {
    const element = document.querySelector('html') as HTMLElement;
    element.className += 'loginPage';

    serverCheck();
    return () => {
      element.className = '';
    }
  }, []);

  useEffect(() => {
    authError === false && serverCheck();
  }, [authError]);

  return (
    <div className={(!authCerts || authCertsFetch) && !authFetch && !authError ? 'certs' : ''}>
      <AuthBackgroundComponent/>
      <div>
        {
          (!authCerts && !authCertsFetch && !authFetch && !authError) &&
            <AuthCertsComponent serverCheck={serverCheck}
                                certsFilesCheck={certsFilesCheck}
                                heartbeatCheck={heartbeatCheck}/>
        }
        <div className={`wrapper-login ${authError || authDuoError ? `auth-error` : ''}`}>
          {
            !authCertsFetch && <img src={loginBg} alt="" className="bg"/>
          }
          {
            authCertsFetch && <SpinnerComponent/>
          }
          {
            ((!authError || authCerts) && !authDuoFetch) && <AuthFormComponent authFetch={authFetch}/>
          }
          {
            (authError || authDuoError) && <AuthFailedComponent/>
          }
          {
            authDuoFetch && !authDuoError && <AuthDuoComponent />
          }
        </div>
      </div>
    </div>
  )
};

export default AuthComponent;